<template>
    <div class="characteristic">
        <div class="contents industry-contents-title">
            <img :width="aboutTitleWidth" :src="aboutTitle">
        </div>
        <div class="contents haracteristic-contents">
            <div class="characteristic-item" v-for="item in characteristic">
                <div class="characteristic-item-top">
                    <img :src="item.titleImg">
                    <p>{{item.title}}</p>
                </div>
                <div class="characteristic-item-bottom">
                    <div class="characteristic-item-bottom-box">
                        <div class="characteristic-item-bottom-list"  v-for="itemlist in item.list">                        
                            <i class="icon iconfont icon-yuandianzhong"></i><p>{{itemlist}}</p>                       
                        </div>
                    </div>                    
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
     props: {
        aboutTitle: {
            type: String,
            required: true,
            default: ""
        },
        aboutTitleWidth:{
            type:String,
            required: true,
            default: "840px"
        },
        characteristic:{
            type:Array,
            required: true,
            default:function(){
                return []
            }
        }
    },
}
</script>
<style scoped>
     /**产品特点 */
    .characteristic-item{
        width:375px;
        height: 416px;
        background-color: #fff;
        text-align: center;
        
    }
    .characteristic-item-top{
        margin-top:37px;
    }
    .characteristic-item-top p{
        color: #333333;
        font-weight: 700;
        font-size: 24px;
        margin-top:30px;
        margin-bottom: 15px;
    }
    .haracteristic-contents{
        display: flex;
        justify-content: space-between;
        overflow: hidden;
    }
    .characteristic-item-bottom-box{
        width: 331px;
        margin-left: 22px;
        border-top: 1px solid rgba(102, 102, 102, 0.6);
        padding-top:25px;
    }
    .characteristic-item-bottom-box .characteristic-item-bottom-list:last-child{
        margin-top: 10px;
    }
    .characteristic-item-bottom-list{        
        overflow: hidden;
    }
    .characteristic-item-bottom-list p{
        font-weight: 400;
        font-size: 14px;
        color: #333;
        margin-top:5px;
        display: inline-block;
        width: 314px;
        text-align: left;
        letter-spacing: 0.06em;
        line-height: 25px;
    }
    .characteristic-item-bottom-list .icon{
      color:#FBB113;
      font-size:15px;
      width:17px;
      float: left;
      margin-top: 10px;
    }
    .industry-contents-title{
         text-align: center;
         padding-top:55px;
         margin-bottom:60px;
     }
</style>


// WEBPACK FOOTER //
// src/components/brand/ProductsAdvantages.vue